define((require) => {
    "use strict";

    const _                           = require("underscore");
    const SlideAnimationModel         = require("shared/ui/experience/widgets/animations/slide/SlideAnimationModel");
    const SlideOutAnimationModel      = require("shared/ui/experience/widgets/animations/slideOut/SlideOutAnimationModel");
    const FadeAnimationModel          = require("shared/ui/experience/widgets/animations/fade/FadeAnimationModel");
    const FadeOutAnimationModel       = require("shared/ui/experience/widgets/animations/fadeOut/FadeOutAnimationModel");
    const ZoomInAnimationModel        = require("shared/ui/experience/widgets/animations/zoomIn/ZoomInAnimationModel");
    const ZoomOutAnimationModel       = require("shared/ui/experience/widgets/animations/zoomOut/ZoomOutAnimationModel");
    const MoveAnimationModel          = require("shared/ui/experience/widgets/animations/move/MoveAnimationModel");
    const SlideAnimationController    = require("shared/ui/experience/widgets/animations/slide/SlideAnimationController");
    const SlideOutAnimationController = require("shared/ui/experience/widgets/animations/slideOut/SlideOutAnimationController");
    const FadeAnimationController     = require("shared/ui/experience/widgets/animations/fade/FadeAnimationController");
    const FadeOutAnimationController  = require("shared/ui/experience/widgets/animations/fadeOut/FadeOutAnimationController");
    const ZoomInAnimationController   = require("shared/ui/experience/widgets/animations/zoomIn/ZoomInAnimationController");
    const ZoomOutAnimationController  = require("shared/ui/experience/widgets/animations/zoomOut/ZoomOutAnimationController");
    const MoveAnimationController     = require("shared/ui/experience/widgets/animations/move/MoveAnimationController");

    /**
     * The different types of animations and non-editor information about them.
     *
     * Editor-specific information goes into {@link AnimationEditorTypes} instead.
     *
     * @class AnimationTypes
     */
    return {
        "SLIDE": {
            id: "slide",
            name: "slide",
            modelClass: SlideAnimationModel,
            animationControllerClass: SlideAnimationController
        },
        "SLIDE_OUT": {
            id: "slideOut",
            name: "slideOut",
            modelClass: SlideOutAnimationModel,
            animationControllerClass: SlideOutAnimationController
        },
        "FADE": {
            id: "fade",
            name: "fade",
            modelClass: FadeAnimationModel,
            animationControllerClass: FadeAnimationController
        },
        "FADE_OUT": {
            id: "fadeOut",
            name: "fadeOut",
            modelClass: FadeOutAnimationModel,
            animationControllerClass: FadeOutAnimationController
        },
        "ZOOM_IN": {
            id: "zoomIn",
            name: "zoomIn",
            modelClass: ZoomInAnimationModel,
            animationControllerClass: ZoomInAnimationController
        },
        "ZOOM_OUT": {
            id: "zoomOut",
            name: "zoomOut",
            modelClass: ZoomOutAnimationModel,
            animationControllerClass: ZoomOutAnimationController
        },
        "MOVE": {
            id: "move",
            name: "move",
            modelClass: MoveAnimationModel,
            animationControllerClass: MoveAnimationController
        },

        /**
         * Gets the animation type for the given type string.
         *
         * @param {String} typeString The type string.
         * @returns {Object} The type descriptor matching the given type, or undefined if not found.
         */
        fromString(typeString) {
            return _.find(this, (type) => (type.id === typeString));
        }
    };
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/AnimationTypes.js